import styled, { css } from 'styled-components';
import { getColorByName } from '~/helpers/getColors';
import { HoverDesktop } from '../CTASkins';
import { getPaddingY, getFontSize } from '../CTA.helpers';

import { mq } from '~/styles/grid';

export const CTAtertiarySkin = css`
  font-family: ${(props) => props.theme.font.regular};
  padding: ${(props) => getPaddingY(props.size) - 2}px 0;
  font-size: ${(props) => getFontSize(props.size)};
  color: ${({ theme }) => getColorByName(theme, theme.cta.tertiaryFontColor)};
  line-height: ${(props) => props.theme.cta.tertiaryLineHeight};

  .iconBefore,
  .iconAfter {
    svg {
      max-height: ${(props) => getFontSize(props.size)};
      width: auto;
    }
  }

  span + span {
    margin-top: 0;
  }

  ${({ theme, isBrand }) =>
    isBrand &&
    css`
      color: ${getColorByName(theme, theme.cta.brand.tertiaryFontColor)};
    `};
`;

export const CTAtertiaryWithIconSkin = css`
  ${CTAtertiarySkin};
  align-items: flex-start;
  display: flex;
  gap: 10px;
  justify-content: flex-start;

  .iconBefore,
  .iconAfter {
    display: flex;
    align-items: center;
    height: calc(${(props) => getFontSize(props.size)} * 1.5);
    flex-shrink: 0;
  }

  ${({ $fullWidth }) =>
    $fullWidth &&
    css`
      justify-content: space-between;
    `};

  ${HoverDesktop};
  @media (${mq.mdUp}) {
    .text::after {
      background-color: ${({ theme, isBrand }) =>
        isBrand
          ? getColorByName(theme, theme.cta.brand.tertiaryFontColor)
          : getColorByName(theme, theme.cta.tertiaryFontColor)} !important;
    }
  }
`;

export const CTAtertiaryWithAniIconSkin = css`
  ${CTAtertiaryWithIconSkin};
`;

export const CTAtertiaryWithAniIcon = styled.div`
  ${CTAtertiaryWithAniIconSkin};
`;

export const CTAtertiaryWithIcon = styled.div`
  ${CTAtertiaryWithIconSkin}
`;

export const CTAlink = styled.div`
  ${CTAtertiarySkin}
`;

export const CTAlinkInline = styled.div`
  ${CTAtertiaryWithIconSkin}
  padding: 0;
`;
